"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormContext = void 0;
const react_1 = __importStar(require("react"));
const use_validation_1 = __importDefault(require("../validation/use-validation"));
exports.FormContext = react_1.default.createContext({});
const emptyArray = [];
const noop = () => null;
/**
 * A custom hook providing state & actions for a given field/path.
 */
const useForm = (path, params) => {
    const _a = (0, react_1.useContext)(exports.FormContext), _b = _a.context, { handleChange = noop, removePaths = noop } = _b, context = __rest(_b, ["handleChange", "removePaths"]), { setContext } = _a;
    const config = context.configs[path] || {};
    const initialValue = context.initialValues[path] || '';
    const contextState = context.updatedFields[path] || {};
    const AddOn = getAddOn(config, context);
    const { onBlur, onChange: useValOnChange, displayErrors, errors: useValErrs, value: useValValue } = (0, use_validation_1.default)(Object.assign(Object.assign(Object.assign({ errors: emptyArray, value: initialValue || '', validator: params === null || params === void 0 ? void 0 : params.validator, eventProcessor: params === null || params === void 0 ? void 0 : params.eventProcessor, consumerOnChange: getConsumerOnChange(handleChange, path) }, config), contextState), { type: (params === null || params === void 0 ? void 0 : params.type) || config.type }));
    return [
        Object.assign(Object.assign({}, contextState), { value: useValValue, errors: useValErrs, config,
            AddOn }),
        {
            onChange: useValOnChange,
            onBlur,
            displayErrors,
            setFormState: getSetFormState(setContext, handleChange),
            removePaths
        }
    ];
};
exports.default = useForm;
/**
 * Initialize onChange for a given path
 *
 * @param handleChange The form container's handleChange function
 * @param path
 */
function getConsumerOnChange(handleChange, path) {
    return (_, { value = '', errors = [] }) => {
        handleChange({
            [path]: { value, errors }
        });
    };
}
/**
 * Returns a function used to update the global context object and
 * calls handleChange so those updates are propagated.
 */
function getSetFormState(setContext, handleChange) {
    return (params) => {
        setContext((context) => {
            return Object.assign(Object.assign({}, context), { configs: Object.assign(Object.assign({}, context.configs), params.config), initialValues: Object.assign(Object.assign({}, context.initialValues), params.initialValue) });
        });
        // trigger a "change" so that props.onChange is called which
        // will make the consumer aware of any config/value changes
        handleChange({});
    };
}
/**
 * Returns an add-on (React component) if it has been declared in
 * the field's config.
 *
 * @param {Object} params
 * @param {Object} params.config
 * @param {Object} params.context
 * @returns {Object|Function} React component
 */
function getAddOn(config, context) {
    if (config &&
        config.addOn &&
        context.addOns &&
        context.addOns[config.addOn]) {
        return context.addOns[config.addOn];
    }
    return noop;
}
//# sourceMappingURL=use-form.js.map